import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchAnalyticsOverviewAPI } from "../apis/analytics.api";
import { errorToastify } from "../utils/toastify.util";

const initialState = {
    isLoader: false,
    error: null,
    filter: null,
    acquisition: null,
    accountStatus: null,
    activity: null,
};

export const getAnalyticsOverview = createAsyncThunk(
    "analytics/getAnalyticsOverview",
    async (params = {}, { rejectWithValue }) => {
        try {
            return await fetchAnalyticsOverviewAPI(params);
        } catch (err) {
            const message =
                err?.response?.data?.message ||
                err?.response?.data?.mesasge ||
                "Failed to fetch analytics";
            errorToastify(message);
            return rejectWithValue({ message });
        }
    }
);

const analyticsSlice = createSlice({
    name: "analytics",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getAnalyticsOverview.pending, (state) => {
            state.isLoader = true;
            state.error = null;
        });
        builder.addCase(getAnalyticsOverview.fulfilled, (state, action) => {
            state.isLoader = false;

            const result = action.payload?.result;

            if (action.payload?.success && result) {
                state.filter = result.filter || null;
                state.acquisition = result.acquisition || null;
                state.accountStatus = result.accountStatus || null;
                state.activity = result.activity || null;
            } else {
                state.acquisition = null;
                state.accountStatus = null;
                state.activity = null;
            }
        });
        builder.addCase(getAnalyticsOverview.rejected, (state, action) => {
            state.isLoader = false;
            state.error = action?.payload?.message || "Failed to fetch analytics";
            state.acquisition = null;
            state.accountStatus = null;
            state.activity = null;
        });
    },
});

export default analyticsSlice.reducer;
